
import moment from 'moment';
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import WithdrawService from '@/services/withdraw.service';
import lazyInject from '@/di';
import { WithdrawExamineStatus } from '@/common/enum/withdraw';
import RejectModal from './common/RejectModal.vue';
import { CApplyExamineList } from '@/models/apply.model';
import { IApplyExamineList } from '@/common/interface/apply';
import { AuthEnum } from '@/services/permission.service';
import UTILService from '@/services/utils.service';
import ShopService from '@/services/shop.service';
import UserService from '@/services/user.service';
import ReviewDetail from './ReviewDetail.vue';
import { handleNum } from '@/common/utils';
import ClickRejectionModal from './common/ClickRejectionModal.vue';

@Component({
  components: {
    'reject-modal': RejectModal,
    'review-detail': ReviewDetail,
    'click-rejection-modal': ClickRejectionModal,
  },
})
export default class ApplyExamine extends Vue {
  selectedRowKeys: any = []; // Check here to configure the default column
  mlist: any[] = [
    {
      label: '提现到门店',
      value: 'platform',
    },
    {
      label: '提现到品牌',
      value: 'ka',
    },
  ];

  @lazyInject(UTILService)
  utilService!: UTILService;


  @lazyInject(UserService)
  userService!: UserService;

  @lazyInject(WithdrawService)
  withdrawService!: WithdrawService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  handleNum = handleNum;

  @Ref('rejectModal')
  rejectModal?: RejectModal;

  @Ref('reviewDetail')
  reviewDetail?: ReviewDetail;

  @Ref('clickRejectionModal')
  clickRejectionModal?: ClickRejectionModal;

  AuthEnum = AuthEnum;

  auditType: any = '待审核';

  totalAmount = 0;

  encryptAccount = '';

  WithdrawExamineStatus = WithdrawExamineStatus;

  statusList: WithdrawExamineStatus[] = [
    WithdrawExamineStatus.待审核,
    WithdrawExamineStatus.审核未通过,
    WithdrawExamineStatus.提现成功,
    WithdrawExamineStatus.提现中,
  ];

  filterForm: {
    withdrawal_no: string;
    status: any;
    apply_ts_start: string;
    apply_ts_end: string;
    verify_ts_start: string;
    verify_ts_end: string;
    ka_type: any;
    ka_id: any;
    shop_name: any;
    poi: any;
  } = {
      withdrawal_no: '',
      status: undefined,
      apply_ts_start: '',
      apply_ts_end: '',
      verify_ts_start: '',
      verify_ts_end: '',
      ka_type: 'platform',
      ka_id: '',
      shop_name: '',
      poi: '',
    };

  verifyts_data: any[] = [];
  applyts_data: any[] = [];

  columns: any[] = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 150,
    },
    {
      title: '提现状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 150,
    },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 150,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 150,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      width: 150,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      width: 150,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
      width: 150,
    },
  ];

  platformColumns = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 240,
    },
    {
      title: '提现状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 150,
    },
    {
      title: '门店名称',
      dataIndex: 'shopName',
      align: 'center',
      width: 300,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      align: 'center',
      width: 150,
    },
    {
      title: '城市',
      dataIndex: 'city',
      align: 'center',
      width: 150,
    },
    {
      title: '年费代运营',
      dataIndex: 'agentName',
      align: 'center',
      width: 150,
    },
    // {
    //   title: '提现渠道',
    //   dataIndex: 'channel',
    //   align: 'center',
    //   width: 120,
    //   scopedSlots: { customRender: 'channel' },
    // },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 240,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 240,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      width: 240,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 150,
    },
  ];

  kaColumns = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 240,
    },
    {
      title: '提现状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 150,
    },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 200,
    },
    {
      title: '品牌',
      dataIndex: 'kaName',
      align: 'center',
      width: 150,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 240,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      width: 240,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 150,
    },
  ];

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    onChange: this.paginationChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  kalist: any[] = [];

  data: any[] = [];

  loading = true;

  @Watch('$route')
  routeChange() {
    const { page, pageSize, withdrawal_no, status, apply_ts_start, apply_ts_end, verify_ts_start, verify_ts_end, auditType, ka_type, ka_id, shop_name, poi } = this.$route.query;
    const params: any = {
      page: page ? Number(page) : 1,
      pageSize: pageSize ? Number(pageSize) : 10,
    };
    this.auditType = auditType || '待审核';
    this.pagination.current = page ? Number(page) : 1;
    if (withdrawal_no) {
      this.filterForm.withdrawal_no = withdrawal_no as string;
      params.withdrawal_no = withdrawal_no;
    }
    if (status || status === '0') {
      this.filterForm.status = Number(status);
      params.status = status;
    }
    if (auditType && auditType === '全部') {
      params.status = status;
    } else {
      params.status = 0;
    }
    if (apply_ts_start && apply_ts_end) {
      params.apply_ts_start = apply_ts_start;
      params.apply_ts_end = apply_ts_end;
      this.filterForm.apply_ts_start = apply_ts_start as string;
      this.filterForm.apply_ts_end = apply_ts_end as string;
      this.applyts_data = [moment(apply_ts_start as string), moment(apply_ts_end as string)];
    }
    if (verify_ts_start && verify_ts_end) {
      params.verify_ts_start = verify_ts_start;
      params.verify_ts_end = verify_ts_end;
      this.filterForm.verify_ts_start = verify_ts_start as string;
      this.filterForm.verify_ts_end = verify_ts_end as string;
      this.verifyts_data = [moment(verify_ts_start as string), moment(verify_ts_end as string)];
    }
    params.ka_type = ka_type || 'platform';
    this.filterForm.ka_type = ka_type || 'platform';
    if (ka_type === 'ka') {
      this.columns = this.kaColumns;
    } else {
      this.columns = this.platformColumns;
    }
    if (ka_id) {
      params.ka_id = ka_id;
      this.filterForm.ka_id = ka_id;
    }
    if (shop_name) {
      params.shop_name = shop_name;
      this.filterForm.shop_name = shop_name;
    }
    if (poi) {
      params.poi = poi;
      this.filterForm.poi = poi;
    }
    this.pagination.current = +page;
    this.getOrderList(params);
  }


  async LookShopDetail(title: string, encryptAccount: string) {
    const data = {
      encrypt_phone: encryptAccount,
      operate_type: title,
    };
    // console.log(data);
    try {
      const res = await this.utilService.postPhoneDecrypt(data);
      if (res) {
        this.encryptAccount = res;
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }
  async getKaList() {
    const id = this.userService.currentUser()?.id;
    const response = await this.shopService.postKaUserList(id);
    if (response) {
      this.kalist = response;
    }
  }
  paginationChange(page: number) {
    this.pagination.current = page;
    const { withdrawal_no, status, apply_ts_start, apply_ts_end, verify_ts_start, verify_ts_end, ka_type, ka_id, shop_name, poi } = this.filterForm;
    const query: any = {
      page,
      pageSize: this.pagination.pageSize,
      auditType: this.auditType,
    };
    if (withdrawal_no) {
      query.withdrawal_no = withdrawal_no;
    }
    if (status || status === 0) {
      query.status = status;
    }
    if (apply_ts_start && apply_ts_end) {
      query.apply_ts_start = apply_ts_start;
      query.apply_ts_end = apply_ts_end;
    }
    if (verify_ts_start && verify_ts_end) {
      query.verify_ts_start = verify_ts_start;
      query.verify_ts_end = verify_ts_end;
    }
    if (ka_type) {
      query.ka_type = ka_type;
    }
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
    }
    this.$router.push({
      query,
    });
  }
  selectedAmount = 0;
  onSelectChange(selectedRowKeys: any[]) {
    this.selectedRowKeys = selectedRowKeys;
    // this.selectedAmount = this.data.filter((item: any) => selectedRowKeys.includes(item.id)).reduce((acc: number, item: any) => acc + Number(item.money), 0);
  }
  onSelect(record: any, selected: any) {
    if (selected) {
      this.selectedAmount += Number(record.money);
      this.SelectAllList.push(record);
    } else {
      this.selectedAmount -= Number(record.money);
      this.SelectAllList = this.SelectAllList.filter((item: any) => item.id !== record.id);
    }
    this.selectedAmount = Number((this.selectedAmount).toFixed(2));
  }
  SelectAllList: any[] = [];
  onSelectAll(selected: any, selectedRows: any, changeRows: any) {
    const cdata: any[] = [];
    changeRows.forEach((element: any) => {
      cdata.push(element);
    });
    const cdataid = cdata.map((item: any) => item.id);

    if (selected) {
      this.SelectAllList = [...changeRows, ...this.SelectAllList];
    } else {
      this.SelectAllList = this.SelectAllList.filter((item: any) => !cdataid.includes(item.id));
    }
    this.selectedAmount = this.SelectAllList.reduce((acc: number, item: any) => acc + Number(item.money), 0);
    this.selectedAmount = Number((this.selectedAmount).toFixed(2));
  }

  changeAuditList() {
    // this.auditType = type;
    const { withdrawal_no, status, apply_ts_start, apply_ts_end, ka_type, ka_id, shop_name, poi } = this.$route.query;
    const query: any = {
      page: 1,
      pageSize: this.pagination.pageSize,
    };
    if (withdrawal_no) {
      query.withdrawal_no = withdrawal_no;
    }
    if (status || status === '0') {
      query.status = status;
    }
    if (apply_ts_start && apply_ts_end) {
      query.apply_ts_start = apply_ts_start;
      query.apply_ts_end = apply_ts_end;
    }
    if (ka_type) {
      query.ka_type = ka_type;
    }
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
    }
    query.auditType = this.auditType;
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  async batchAudit() {
    if (this.selectedRowKeys.length === 0) {
      this.$message.warning('请至少选择一条记录');
      return;
    }
    const res = await this.withdrawService.withdrawVerifyAmount({
      type: this.filterForm.ka_type === 'platform' ? 'shop' : 'ka',
      ids: this.selectedRowKeys,
    });
    const text = res;
    const h = this.$createElement;
    this.$confirm({
      title: '提示',
      width: 500,
      content: h('div', { style: { display: 'flex', alignItems: 'center' } }, [
        h('p', '确定要审核已勾选的记录吗？总金额为'),
        h('p', { style: { color: '#f00', fontWeight: 'bold', fontSize: '16px' } }, text),
        h('p', '元'),
      ]),
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.batchTransfer();
      },
    });
  }
  /** 批量转账 */
  async batchTransfer() {
    const params = {
      ids: this.selectedRowKeys,
      type: this.filterForm.ka_type === 'platform' ? 'shop' : 'ka',
    };
    const res = await this.withdrawService.postBatchTransfer(params);
    if (res) {
      this.$message.success('转账成功');
      this.selectedRowKeys = [];
      this.search(false);
      this.selectedAmount = 0;
    }
  }
  async batchAllAudit() {
    const res = await this.withdrawService.withdrawVerifyAmount({
      type: this.filterForm.ka_type === 'platform' ? 'shop' : 'ka',
      ids: [],
    });
    const text = res;
    const h = this.$createElement;
    this.$confirm({
      title: '提示',
      width: 500,
      content: h('div', { style: { display: 'flex', alignItems: 'center' } }, [
        h('p', '确定要审核所有记录吗？总金额为'),
        h('p', { style: { color: '#f00', fontWeight: 'bold', fontSize: '16px' } }, text),
        h('p', '元'),
      ]),
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        this.batchAllTransfer();
      },
      onCancel: () => {
      },
    });
  }

  batchReject() {
    this.clickRejectionModal?.init();
  }
  /** 全部转账 */
  async batchAllTransfer() {
    const params = {
      type: this.filterForm.ka_type === 'platform' ? 'shop' : 'ka',
    };
    const res = await this.withdrawService.postBatchTransferAll(params);
    if (res) {
      this.$message.success('转账成功');
      this.selectedRowKeys = [];
      this.search(false);
      this.selectedAmount = 0;
    }
  }
  reject(id: string) {
    this.rejectModal?.open(id);
  }

  search(val?: any) {
    // console.log(val);
    const { apply_ts_start, apply_ts_end, status, withdrawal_no, ka_type, verify_ts_start, verify_ts_end, ka_id, shop_name, poi } = this.filterForm;
    const query: any = {
      page: val ? this.pagination.current : 1,
      pageSize: this.pagination.pageSize,
      auditType: this.auditType,
    };
    if (withdrawal_no) {
      query.withdrawal_no = withdrawal_no;
    }
    if (status || Number(status) === 0) {
      query.status = status as string;
    }
    if (apply_ts_start && apply_ts_end) {
      query.apply_ts_start = apply_ts_start;
      query.apply_ts_end = apply_ts_end;
    }
    if (ka_type) {
      query.ka_type = ka_type;
    }
    if (verify_ts_start && verify_ts_end) {
      query.verify_ts_start = verify_ts_start;
      query.verify_ts_end = verify_ts_end;
    }
    if (ka_type === 'platform') {
      this.columns = this.platformColumns;
    } else {
      this.columns = this.kaColumns;
    }
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
    }
    this.pagination.current = 1;
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  resetQuery() {
    this.filterForm = {
      withdrawal_no: '',
      status: undefined,
      apply_ts_start: '',
      apply_ts_end: '',
      ka_type: 'platform',
      verify_ts_start: '',
      verify_ts_end: '',
      ka_id: '',
      shop_name: '',
      poi: '',
    };
    this.applyts_data = [];
    this.verifyts_data = [];
    this.columns = this.platformColumns;
    const query: any = {
      page: 1,
      pageSize: this.pagination.pageSize,
      auditType: this.auditType,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  go(routeName: string, id: string, no: string): void {
    // this.$router.push({
    //   name: routeName,
    //   params: {
    //     id,
    //     no,
    //   },
    // });
    this.reviewDetail?.open(id, no);
  }

  onChangeApply(dates: any) {
    this.applyts_data = dates;
    this.filterForm.apply_ts_start = dates[0]?.format('YYYY-MM-DD');
    this.filterForm.apply_ts_end = dates[1]?.format('YYYY-MM-DD');
  }

  onChangeVerify(dates: any) {
    this.verifyts_data = dates;
    this.filterForm.verify_ts_start = dates[0]?.format('YYYY-MM-DD');
    this.filterForm.verify_ts_end = dates[1]?.format('YYYY-MM-DD');
  }

  refresh() { }

  async getOrderList(param: any) {
    const params: any = param;
    this.loading = true;
    if (params.apply_ts_start && params.apply_ts_end) {
      params.apply_ts_start = `${params.apply_ts_start} 00:00:00`;
      params.apply_ts_end = `${params.apply_ts_end} 23:59:59`;
    }
    if (params.verify_ts_start && params.verify_ts_end) {
      params.verify_ts_start = `${params.verify_ts_start} 00:00:00`;
      params.verify_ts_end = `${params.verify_ts_end} 23:59:59`;
    }
    if (params.ka_type === 'platform') {
      delete params.ka_id;
      const res = await this.withdrawService.withdrawalOrderList(params);
      if (res) {
        this.loading = false;
        const data = res.list.map((item: IApplyExamineList) => CApplyExamineList.from(item));
        this.data = data;
        this.totalAmount = res.total_amount;
        this.pagination.total = res.total;
      }
    } else {
      delete params.shop_name;
      delete params.poi;
      const res = await this.withdrawService.withdrawalOrderListKa(params);
      if (res) {
        this.loading = false;
        const data = res.list.map((item: IApplyExamineList) => CApplyExamineList.from(item));
        this.data = data;
        this.pagination.total = res.total;
        this.totalAmount = res.total_amount;
      }
    }
  }

  mounted() {
    // const page = this.pagination.current;
    // const params = {
    //   page,
    //   pageSize: this.pagination.pageSize,
    // };
    // this.getOrderList(params);
    this.routeChange();
    this.getKaList();
  }
}
